// 创建礼物面板
import CreateGiftItem from './host/gift/create-item';
// 支付宝跳转中间页面
import AlipayRedirect from './component/recharge/tool/alipay-redirect';
// 微信跳转中间页面
import WxpayRedirect from './component/recharge/tool/wechat-redirect';
// 没有权限访问
import NoPermission from './host/noperm';
import {asyncComponent as async} from './async';

// 登录
export const Login = async(() => import(/* webpackChunkName: "login" */ './host/login'));
// 落地页
export const Land = async(() => import(/* webpackChunkName: "land" */ './host/land'));
// 礼物面板列表
export const Project = async(() => import(/* webpackChunkName: "project" */ './host/project'));
// 项目收入详情
export const ProjectDetail = async(() => import(/* webpackChunkName: "land" */ './host/project/project-detail'));
// 修改头像
export const PhotoEdit = async(() => import(/* webpackChunkName: "photo-edit" */ './host/profile/photo-edit'));
// 个人收入
export const Earnings = async(() => import(/* webpackChunkName: "earnings" */ './host/earnings'));
// 个人信息
export const Profile = async(() => import(/* webpackChunkName: "profile" */ './host/profile'));
export const Wallet = async(() => import(/* webpackChunkName: "wallet" */ './host/wallet'));

// 送礼物的页面
export const Gift = async(() => import(/* webpackChunkName: "giftmain" */ './gift/index'));
// 单个项目排行榜
export const LeaderBoard = async(() => import(/* webpackChunkName: "leaderboard" */ './gift/leaderboard'));

// IM相关
export const IMS = async(() => import(/* webpackChunkName: "ims" */ './im'));
export const SingleChat = async(() => import(/* webpackChunkName: "singlechat" */ './im/singlechat'));
export const FriendListView = async(() => import(/* webpackChunkName: "friendlist" */ './im/friendlist'));
export const FriendApply = async(() => import(/* webpackChunkName: "friendapply" */ './im/friendapply'));

// 礼物上链的操作
export const BlockChainView = async(() => import(/* webpackChunkName: "blockchain" */ './gift/blockchain'));
export const GiftShowView = async(() => import(/* webpackChunkName: "giftshow" */ './gift/blockchain/giftshow'));

export {CreateGiftItem, AlipayRedirect, NoPermission, WxpayRedirect};



// WEBPACK FOOTER //
// ./js/views.js